import { render, staticRenderFns } from "./CaseUploadsActions.vue?vue&type=template&id=4c9b6e8e"
import script from "./CaseUploadsActions.vue?vue&type=script&lang=js"
export * from "./CaseUploadsActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports